import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import {
  getMemberInitials,
  getHasElementsInArray,
  getUserFullName,
  getUserFullNameOrEmail,
} from 'utils';
import { DataRoomMember } from 'router/subrouters/DataRoom/models/DataRoomMember';

import './DataRoomTeam.styles.scss';

type DataRoomTeamProps = {
  className?: string;
  name: string;
  members: DataRoomMember[];
};

const DataRoomTeam: React.FC<DataRoomTeamProps> = (props) => {
  const { className, name, members } = props;

  const classes = classNames('data-room-team', className);

  const { t } = useTranslation();

  return (
    <div className={classes}>
      <p className="data-room-team__name">
        {t('currentMembersInTeam', { name })}
      </p>

      {getHasElementsInArray(members) ? (
        <ul className="data-room-team__members">
          {members.map((member) => {
            const { _id, firstName, lastName, email } = member || {};
            return (
              <li key={_id}>
                <span className="data-room-team__avatar">
                  {getMemberInitials(
                    getUserFullName(firstName, lastName),
                    email,
                  )}
                </span>

                <span className="data-room-team__label">
                  {getUserFullNameOrEmail(member)}
                </span>
              </li>
            );
          })}
        </ul>
      ) : (
        <p className="data-room-team__empty">{t('noMembers')}</p>
      )}
    </div>
  );
};

export default DataRoomTeam;
